import * as constants from './constants';

export const getSuggestedItems = (payload) => ({ type: constants.GET_SUGGESTED_ITEMS, payload });
export const resetSuggestedItems = () => ({ type: constants.RESET_SUGGESTED_ITEMS });
export const getSuggestedItemsSuccess = (payload) => ({
  type: constants.GET_SUGGESTED_ITEMS_SUCCESS,
  payload,
});
export const getSuggestedItemsError = (payload) => ({
  type: constants.GET_SUGGESTED_ITEMS_ERROR,
  payload,
});
